import Axios from "axios";
import config from '../config';
import {fromWei} from "web3-utils"

const initializers = {};

function returnAxiosInstance() {
    return Axios.create(initializers);
}

export async function get(url) {
    const axios = await returnAxiosInstance();
    return axios.get(config.backendApiBaseUrl + url);
}

export async function post(url, requestData) {
    const axios = await returnAxiosInstance();
    return axios.post(config.backendApiBaseUrl + url, requestData);
}

export async function randomAvatar() {
    return await get('user/random-avatar');
}

export function prepareItems(items, users) {
    let result = [];
    for (let item of items) {
        let u = JSON.parse(JSON.stringify(item));
        let price = item.price || '0';
        u.price = price;
        u.ether_price = fromWei(`${price}`, 'ether');

        u.owner = users[item.currentOwner] ?? users[item.owner];
        result.push(u);
    }
    return result;
}